export function formatStringPatternCheck() {
  return "string must match pattern";
}
